import { unwrapCalendarUserSettingsResponse } from '@/app/(main)/calendar/utils/mapCalendarUserSettings';
import { USER_SETTINGS_IDENTIFIERS } from '@/consts/user-settings';
import { useGetUserSettingsQuery } from '@/hooks/api/useGetUserSettingsQuery';
import type { CalendarPreferences } from '@/types/calendarTypes';

export function useGetCalendarPreferencesQuery() {
  return useGetUserSettingsQuery<CalendarPreferences>({
    identifier: USER_SETTINGS_IDENTIFIERS.CALENDAR_VISIBILITY_TOOGLES,
    staleTime: Number.POSITIVE_INFINITY,
    suppressErrorToast: true,
    mapData: unwrapCalendarUserSettingsResponse,
  });
}
